module.exports = __webpack_public_path__ + "img/van.8cb4534b.svg";